import React from 'react';

// Type
import { TBaData } from 'pages/Thesaurus/reducer';

// components
import CartBio from 'components/Carts/CartBio';

// Interface
interface IList {
	size?: number,
	page?: number,
	data?: TBaData[],
}

export const List = ({ data, size, page = 1 }: IList): any => {
	return !!data?.length ? data.map((item: TBaData, index: number) => {
		const uniqId = index === 0 ? 'cart-bio__uniq-id' : '';
		const uniqIdPrice = index === 0 ? 'cart-bio__uniq-id-price' : '';
		const uniqIdCheckbox = index === 0 ? 'cart-bio__uniq-id-checkbox' : '';

		const numeration = `${(page || 0) * +(size || 0) + index + 1}`;
		return <CartBio
			{...item}
			key={index}
			numeration={numeration}

			uniqId={uniqId}
			uniqIdPrice={uniqIdPrice}
			uniqIdCheckbox={uniqIdCheckbox}
		/>;
	}) : <></>;
};

export default List;
